import { render, staticRenderFns } from "./WheelIndicator.vue?vue&type=template&id=069636a5&"
import script from "./WheelIndicator.vue?vue&type=script&lang=ts&"
export * from "./WheelIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports